/*
         * @ngdoc function
         * @name ePay.Model:Session_AppleDetailsModel
         * @description
         * Model
         */
import { Session_AppleAddressModel } from './Session_AppleAddressModel';

export class Session_AppleDetailsModel {
	billingAddress: Session_AppleAddressModel;

	constructor(
		billingAddress?: Session_AppleAddressModel
	) {
		this.billingAddress = billingAddress || new Session_AppleAddressModel();
	}
}
